"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StartPageChart = void 0;
var Backbone = __importStar(require("backbone"));
var underscore_1 = __importDefault(require("underscore"));
var chartSelection_1 = require("../models/chartSelection");
var jquery_1 = __importDefault(require("jquery"));
var adaptiveCharts_1 = require("../../adaptiveCharts");
var StartPageChart = /** @class */ (function (_super) {
    __extends(StartPageChart, _super);
    function StartPageChart() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StartPageChart.prototype.initialize = function () {
        var _this = this;
        underscore_1.default.bindAll(this, 'onChangeFactor', 'onChangeMunicipality');
        this.select = jquery_1.default(this.$el.data('factorSelect'));
        this.select.on('change', this.onChangeFactor);
        this.autocomplete = jquery_1.default(this.$el.data('municipalitySelect')).data('view');
        this.autocomplete.$el.on('suggestion:clicked', this.onChangeMunicipality);
        // Ugliest hack ever - we need to kill this chart
        jquery_1.default('.js-chart-excel-download').click(function (e) {
            e.preventDefault();
            var model = new chartSelection_1.ChartSelection({ factor: _this.factor });
            return model.downloadAsExcel();
        });
        // default chart
        this.factor = 'summary_evaluation';
        return this.$el.html(StartPageChart.template());
    };
    StartPageChart.prototype.render = function () {
        var _a, _b, _c, _d;
        var activeYear = 2019;
        var presentable = underscore_1.default.includes([
            'knowledge_of_muni_work',
            'advice_on_permission',
            'muni_contact_latest_year',
            'muni_contact_latest_year_about',
            'muni_contact_hesitate',
            'municipality_runs_competing_businesses',
            'business_climate_change_5_years',
            'crime_a_problem',
            'survey_contact_reachable',
            'survey_contact_understanding',
            'survey_contact_clearfee',
            'survey_contact_handling',
            'survey_contact_digitized',
            'crime_change_2years',
            'company_relocate',
            'crime_risk_kind'
        ], this.factor)
            ? 'SurveySimpleBarchart'
            : 'SurveyFactorBoth';
        if (underscore_1.default.includes(['company_relocate', 'crime_change_2years', 'crime_a_problem', 'crime_risk_kind'], this.factor)) {
            activeYear = 2017;
        }
        if (underscore_1.default.includes(['muni_contact_hesitate', 'knowledge_of_muni_work'], this.factor)) {
            activeYear = 2016;
        }
        if (underscore_1.default.includes(['advice_on_permission', 'business_climate_change_5_years', 'municipality_runs_competing_businesses'], this.factor)) {
            activeYear = 2018;
        }
        var query = {
            factor: window.factorAPINames[(_a = this.factor) !== null && _a !== void 0 ? _a : ''],
            kommun: (this.municipality || 'Sverige'),
            type: 'Företagare',
            show_shares: false,
            title: (_b = window === null || window === void 0 ? void 0 : window.factorNames) === null || _b === void 0 ? void 0 : _b[(_c = this.factor) !== null && _c !== void 0 ? _c : ''],
            year: activeYear,
        };
        // @ts-ignore - supress always false temporary
        if (presentable === 'InDepthSurveyQuestions') {
            query.percentage = true;
        }
        var isFactorWithoutGradingScale = underscore_1.default.includes(chartSelection_1.ChartSelection.factorsWithoutGradingScale, this.factor);
        jquery_1.default('.js-grading-scale').toggle(!isFactorWithoutGradingScale);
        // Aaargh, copying this conditional from bigchart...
        var hiddenGradingScaleCopy = [
            "knowledge_of_muni_work",
            "most_prioritized_actions",
            'crime_a_problem',
            'crime_change_2years',
            'crime_risk_kind',
            'company_relocate',
            'advice_on_permission',
            'business_climate_change_5_years',
            'municipality_runs_competing_businesses'
        ];
        if (underscore_1.default.includes(hiddenGradingScaleCopy, this.factor)) {
            jquery_1.default('#js-grading-scale-1-6').hide();
        }
        else {
            jquery_1.default('#js-grading-scale-1-6').show();
        }
        adaptiveCharts_1.Fklimat.renderTo('start_page_chart', presentable, query, null, {});
        var description = window.factorDescriptions[(_d = this.factor) !== null && _d !== void 0 ? _d : ''];
        if (this.factor === 'crime_a_problem') {
            description = 'Upplever du att brottslighet är ett problem för ditt företag?';
        }
        if (this.factor === 'company_relocate') {
            description = 'Har du någon gång övervägt att flytta ditt företag till en kommun med ett bättre företagsklimat?';
        }
        if (this.factor === 'crime_change_2years') {
            description = 'Hur upplever du att brottsligheten mot ditt företag har förändrats under de senaste två åren?';
        }
        jquery_1.default('.js-factor-description').html(description);
        return this;
    };
    StartPageChart.prototype.onChangeFactor = function (e) {
        var val = jquery_1.default(e.target).val();
        if (typeof val === 'string') {
            this.factor = val;
        }
        else {
            console.log("Unexpected value: " + val);
        }
        return this.render();
    };
    StartPageChart.prototype.onChangeMunicipality = function () {
        this.municipality = this.autocomplete.field.val();
        return this.render();
    };
    StartPageChart.template = underscore_1.default.template("\n        <div id=\"start_page_chart\" class=\"chart\"></div>\n    ");
    return StartPageChart;
}(Backbone.View));
exports.StartPageChart = StartPageChart;
